import { render } from "./마취통증학과.vue?vue&type=template&id=2441560e"
import script from "./마취통증학과.vue?vue&type=script&lang=js"
export * from "./마취통증학과.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__